import { GenericDateFilterFactory } from "../_generics";
import { GENERIC_IDS } from "../_constants/generics.constants";

export const ProtectLogsDateFilter = GenericDateFilterFactory(GENERIC_IDS.PROTECT);